import { SCENARIO_DEPLOYMENT_TYPES } from "../../../../simulate/constants";
import { isOperateMode } from "../../../hooks/utils";
import { ScenarioResponseType } from "../../../types";
import { GridViewSvg, ListViewSvg } from "./svgs/Svgs";

export const Monitor_Btn_List = [
    { label: 'Beacon', value: 'Beacon' },
    { label: 'EPS', value: 'EPS' },
    { label: 'ADCS', value: 'ADCS' },
    { label: 'Communication', value: 'Communication' },
    { label: 'Propulsion', value: 'Propulsion' },
    { label: 'OBC', value: 'OBC' },
    { label: 'Payload', value: 'Payload' },
]

export const Monitor_view = [
    {
        title: 'List',
        icon: <ListViewSvg />,
    },
    {
        title: 'Grid',
        icon: <GridViewSvg />,
    },
]

export const get_monitor_button_list = (scenario: ScenarioResponseType | null, dashboard: string | undefined) => {
    if (!scenario || !dashboard) return []

    const { scenarioDeploymentType, remoteAppConfiguration } = scenario
    const operateMode = isOperateMode(dashboard, scenario)

    // Deployment Mode Flags
    const isValidate = scenarioDeploymentType === SCENARIO_DEPLOYMENT_TYPES.VALIDATE
    const isQuickDeploy = scenarioDeploymentType === SCENARIO_DEPLOYMENT_TYPES.QUICK_DEPLOY
    const isHWIL = scenarioDeploymentType === SCENARIO_DEPLOYMENT_TYPES.HARDWARE_IN_LOOP
    const isTrueTwin = scenarioDeploymentType === SCENARIO_DEPLOYMENT_TYPES.TRUETWIN_COMMAND_CENTER
    const hasPayloadConfig = !!remoteAppConfiguration?.remoteApp?.AppData

    const excluded = new Set<string>()

    if (isValidate) {
        return Monitor_Btn_List
    } else if (operateMode) {
        excluded.add('Payload')
        if (isTrueTwin) excluded.add('Propulsion')
    } else if (isHWIL) {
        excluded.add('Communication')
        excluded.add('Propulsion')
        excluded.add('Beacon')
        if (hasPayloadConfig) excluded.add('Payload')
    } else if (isQuickDeploy) {
        excluded.add('Communication')
        excluded.add('Propulsion')
        excluded.add('Beacon')
        if (hasPayloadConfig) excluded.add('Payload')
    } else {
        excluded.add('Communication')
        excluded.add('Payload')
        excluded.add('Propulsion')
        excluded.add('Beacon')
    }

    return Monitor_Btn_List.filter((btn) => !excluded.has(btn.value))
}
